// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk~" + "swiper" + ".js?ver=" + "f3973a8200b5c2017413" + "";
};